import React from "react";
import { Link } from "react-router-dom";
import { Globe2, Facebook, Instagram, Twitter, Linkedin, ShieldCheck, MapPin, Phone } from "lucide-react";
import { toast } from "sonner";
import { PaymentLogos } from "@/components/PaymentLogos";

const COLS = [
  { title: "Holidays", links: [["Flight + Hotel", "/flight-hotel"], ["City Breaks", "/city-breaks"], ["Beach Holidays", "/beach-holidays"], ["All-Inclusive", "/all-inclusive"], ["Family Holidays", "/family-holidays"], ["Last Minute", "/last-minute"]] },
  { title: "Explore", links: [["Flights", "/flights"], ["Hotels", "/hotels"], ["Car Hire", "/cars"], ["Destination Guides", "/destinations"]] },
  { title: "Support", links: [["Help Centre", "/help"], ["Contact Us", "/contact"], ["Manage Booking", "/manage-booking"], ["Cancellations", "/cancellations"], ["Refunds", "/refunds"]] },
  { title: "Legal", links: [["Privacy Policy", "/privacy"], ["Cookie Policy", "/cookies"], ["Booking Terms", "/terms"], ["Accessibility", "/accessibility"], ["About Us", "/about"]] },
];

export const Footer = () => {
  const submit = (e) => {
    e.preventDefault();
    e.target.reset();
    toast.success("Subscribed! Exclusive deals are on the way ✈");
  };
  return (
    <footer className="bg-slate-950 text-slate-300 mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="mb-5">
              <img src="/wth-logo.png" alt="World Tour Hub Ltd" className="h-10 w-auto rounded-md" />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed max-w-sm">
              The world's most complete travel marketplace. Compare flights, hotels, holiday packages and car hire from
              hundreds of trusted partners — all in one place, at the best price.
            </p>
            <div className="mt-5 text-sm text-slate-400 space-y-1">
              <div className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-brand shrink-0" /> 18 Berkeley Mews, Birmingham, West Midlands, United Kingdom, B25 8PS</div>
              <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-brand" /> +44 20 7946 0000</div>
            </div>
            <form onSubmit={submit} className="mt-6 flex gap-2 max-w-sm" data-testid="newsletter-form">
              <input type="email" required placeholder="Your email for exclusive deals"
                className="flex-1 h-11 px-4 rounded-full bg-slate-900 border border-slate-800 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-brand" />
              <button className="h-11 px-5 rounded-full bg-brand hover:bg-brand-hover text-white font-semibold text-sm transition-colors" data-testid="newsletter-submit">Join</button>
            </form>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
            {COLS.map((c) => (
              <div key={c.title}>
                <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-4">{c.title}</div>
                <ul className="space-y-3">
                  {c.links.map(([label, to]) => (
                    <li key={label}><Link to={to} className="text-sm text-slate-400 hover:text-white transition-colors">{label}</Link></li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4 text-xs text-slate-500">
            <span className="flex items-center gap-1.5"><ShieldCheck className="w-4 h-4 text-emerald-400" /> Secure SSL payments</span>
            <PaymentLogos variant="light" />
          </div>
          <div className="flex items-center gap-3">
            {[Facebook, Instagram, Twitter, Linkedin].map((I, i) => (
              <a key={i} href="#!" className="w-9 h-9 rounded-full bg-slate-900 hover:bg-brand flex items-center justify-center transition-colors">
                <I className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
        <p className="mt-6 text-center text-xs text-slate-600">
          © {new Date().getFullYear()} World Tour Hub Ltd. All rights reserved. Registered in England & Wales, Company No. 17436422. Registered office: 18 Berkeley Mews, Birmingham, West Midlands, United Kingdom, B25 8PS. Secure SSL payments.
        </p>
      </div>
    </footer>
  );
};
